import api, { httpExternal } from "../http";

const loginUser = (payload) => api.post(`/auth/users/login`, { username: payload.username, password: payload.password });

const registerUser = (payload) => {
  const body = {
    username: payload.username,
    name: payload.name,
    password: payload.password
  };
  if (payload.email) body.email = payload.email;
  return api.post(`/auth/users/register`, body);
};

const createUser = (payload) => {
  const body = {
    username: payload.username,
    name: payload.name,
    password: payload.password,
    profile: payload.profile || 'user'
  };
  if (payload.email) body.email = payload.email;
  return api.post(`/auth/users/`, body);
};

const signInUser = (payload) => createUser(payload);

const driverLogin = (payload) => {
  const apiKey = process.env.VUE_APP_LOGISTICS_API_KEY;
  const originId = process.env.VUE_APP_LOGISTICS_ORIGIN_ID;
  if (!apiKey || !originId) {
    return Promise.reject(
      new Error("Logistics API credentials are not configured")
    );
  }
  return httpExternal.get(
    "https://logistics-api.ifood-sandbox.com.br/driver/benefits/v1/drivers/" +
      payload,
    {
      headers: {
        "X-API-Key": apiKey,
        "X-Origin-Identifier": originId,
      },
    }
  );
};

const loginIfood = (payload) =>
  httpExternal.get(
    `https://fleet-api.ifood.com.br/api/logistics/crm-identity/worker`,
    {
      headers: { Authorization: `Bearer ${payload}` },
    }
  );

const zip = (payload) =>
  httpExternal.get(`https://viacep.com.br/ws/${payload.zip}/json/`);

const getDriverData = (publicId) => {
  const driverApiUrl =
    process.env.VUE_APP_DRIVER_API ||
    "https://qfnks6p8c3.execute-api.us-east-1.amazonaws.com";
  return httpExternal.get(`${driverApiUrl}/driver/${publicId}`);
};

export default {
  loginUser,
  registerUser,
  signInUser,
  createUser,
  loginIfood,
  driverLogin,
  zip,
  getDriverData
};
